import {z} from 'zod';
import {elementValidatorExtended} from './elements/element';

export const slideValidator = z.object({
    elements: z.array(elementValidatorExtended),
});
